import * as React from 'react';

const Twitter = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={20} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1424-1246H496v4595h-1920z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M7.548 19.974c9.057 0 14.01-7.674 14.01-14.328q0-.327-.014-.651A10.1 10.1 0 0 0 24 2.387a9.7 9.7 0 0 1-2.828.793A5.04 5.04 0 0 0 23.338.394a9.7 9.7 0 0 1-3.127 1.223A4.87 4.87 0 0 0 16.617.026c-2.72 0-4.925 2.255-4.925 5.035q.001.594.128 1.148C7.728 6 4.1 3.995 1.67.948a5.1 5.1 0 0 0-.667 2.53c0 1.748.87 3.29 2.191 4.193a4.8 4.8 0 0 1-2.23-.63v.064c0 2.44 1.697 4.475 3.95 4.937a4.8 4.8 0 0 1-1.298.177 5 5 0 0 1-.926-.09c.627 2 2.445 3.456 4.6 3.497A9.74 9.74 0 0 1 0 17.712a13.7 13.7 0 0 0 7.548 2.262"
            />
        </g>
    </svg>
);
export default Twitter;
